import * as api from './base';
import * as token from '../utils/token';
import Cookies from 'js-cookie';

const noAuth = {
    data: {
        Code: 211
    }
}

//登录
export const login = (data) => {
    return new Promise((resolve, reject) => {
        api.post({
            url: "Auth/Login",
            auth: false,
            loading: "登录中",
            data
        }).then(res => {
            if (res.Status == 1) {
                token.setToken(res.Data);
            }
            resolve(res)
        }).catch(reject);
    });
}

//刷新令牌
export const refresh = () => {
    return new Promise((resolve, reject) => {
        api.post({
            url: '/Auth/Refresh',
            auth: false,
            data: {
                refreshToken: token.getRefreshToken()
            }
        }).then(res => {
            if (res.Status == 1) {
                token.setToken(res.Data);
                resolve(res);
            } else {
                //清缓存，跳转登录页
                token.clear();
                reject(noAuth);
            }
        }).catch(res => {
            //返回未授权
            reject(noAuth);
        });
    });
}

//修改密码
export const changePwd = (pwd) => api.post({
    url: "/Auth/ChangePwd",
    data: { pwd },
    loading: "提交中"
});

//获取个人信息
export const info = () => {
    return new Promise((resolve, reject) => {
        api.get({
            url: '/Auth/Info'
        }).then(res => {
            if (res.Status == 1) {
                //缓存下来
                Cookies.set("userInfo", res.Data);
                resolve(res);
            }
            else {
                reject(res);
            }
        }).catch(reject);
    });
}